export const DELIVERY = 'DELIVERY'
export const RETURN = 'RETURN'
export const RETURN_BULK_SPLIT = 'RETURN_BULK_SPLIT'
